module.exports = __webpack_public_path__ + "img/small.eecf9358.jpg";